<template>
  <div class="period_setting">
    <flat-pickr v-model="dateRange" :config="config" @on-change="updateDate" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { Korean } from 'flatpickr/dist/l10n/ko.js'

export default {
  components: {
    flatPickr
  },
  props: {
    cateArr: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      now: '',
      dateRange: '',
      config: {
        static: true,
        altFormat: 'Y-m-d',
        altInput: true,
        dateFormat: 'Y-m-d',
        mode: 'range',
        locale: this.dateLocale,
        monthSelectorType: 'static',
        maxDate: this.$moment().format('YYYY-MM-DD')
      },
      monthSelected: -1,
      monthArr: []
    }
  },
  computed: {
    ...mapGetters('my', ['alltemPurchaseStartDate, alltemPurchaseEndDate']),
    dateLocale() {
      return Korean
    },
    dateMiddleText() {
      return ' ~ '
    }
  },
  created() {},
  mounted() {
    this.initDate()
  },
  methods: {
    ...mapActions('modal', ['openModal']),
    ...mapActions('my', [
      'setAlltemPurchaseStartDate',
      'setAlltemPurchaseEndDate'
    ]),
    initDate() {
      const today = this.$moment().format('YYYY-MM-DD')
      const prev6Day = this.$moment()
        .add(-6, 'days')
        .format('YYYY-MM-DD')
      this.setAlltemPurchaseEndDate(today)
      this.setAlltemPurchaseStartDate(prev6Day)

      this.setDateLocale({
        alltemPurchaseStartDate: prev6Day,
        alltemPurchaseEndDate: today
      })
    },
    setDateLocale({ alltemPurchaseStartDate, alltemPurchaseEndDate }) {
      this.config.locale = this.dateLocale
      this.now = this.$moment()
      this.dateRange =
        alltemPurchaseStartDate + this.dateMiddleText + alltemPurchaseEndDate
      this.setMonthArr()
    },
    updateDate(selectedDates) {
      if (selectedDates.length === 2) {
        if (this.checkTerm(selectedDates)) {
          const startDate = this.$moment(selectedDates[0]).format('YYYY-MM-DD')
          const endDate = this.$moment(selectedDates[1]).format('YYYY-MM-DD')

          this.setAlltemPurchaseStartDate(startDate)
          this.setAlltemPurchaseEndDate(endDate)

          this.$emit('changeDate', { startDate, endDate })
        } else {
          this.openModal({
            type: 'alert',
            message: '조회 기간은 최대 7일입니다.<br>날짜를 조정해주세요.'
          })

          this.setAlltemPurchaseStartDate(this.alltemPurchaseStartDate)
          this.setAlltemPurchaseEndDate(this.alltemPurchaseEndDate)
        }
      }
    },
    handleMonth() {
      if (this.monthSelected === -1) return
      let startDate = ''
      let endDate = ''
      const middleText = this.dateMiddleText
      startDate = this.$moment()
        .subtract(this.monthSelected, 'months')
        .startOf('month')
        .format('YYYY-MM-DD')

      if (this.monthSelected === 0) {
        endDate = this.now.format('YYYY-MM-DD')
      } else {
        endDate = this.$moment()
          .subtract(this.monthSelected, 'months')
          .endOf('month')
          .format('YYYY-MM-DD')
      }
      this.dateRange = startDate + middleText + endDate
    },
    setMonthArr() {
      this.monthArr = []
      let year = Number(this.now.format('YYYY')),
        month = Number(this.now.format('M'))
      for (let i = 0; i <= 12; i++) {
        this.monthArr.push(`${year}년 ${month}월`)

        month--
        if (month <= 0) {
          year--
          month = 12
        }
      }
    },
    checkTerm(selectedDates) {
      return (
        this.$moment(selectedDates[0]).diff(
          this.$moment(selectedDates[1]),
          'days'
        ) <= 6
      )
    }
  }
}
</script>

<style lang="scss">
.flatpickr-wrapper {
  width: 210px;
  .form-control {
    font-family: 'Noto Sans KR', sans-serif;
    position: relative;
    width: 100%;
    height: 40px;
    padding: 10px;
    font-size: 16px;
    border: solid 1px #dddddd;
    background-color: transparent;
    cursor: pointer;
  }
}
@media screen and (min-width: 767px) {
  .period_setting {
    .month_select.en.initial {
      .selectbox {
        font-size: 13px;
      }
    }
  }
}
</style>
